import { Dropdown, DropdownButton } from "react-bootstrap";

const DropdownIcon = (props: any) => {

  let icon = props.icon ?? '';
  let dropdownItems = props.dropdownItems ?? [];
  return (
    <>
      <DropdownButton className="dropDownIcon" id="dropdown-basic-button" title={<span className="material-symbols-outlined">{icon}</span>}>
        {dropdownItems.map((dropdownItem: any, index: number) => (
          <Dropdown.Item key={index}>
            <div onClick={dropdownItem?.callback}>{dropdownItem?.title}</div>
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </>
  )
}

export default DropdownIcon;
